
import PortfolioKpiValueChange from "@/components/PortfolioKpiValueChange";
import PercentBox from "@/components/shared/PercentBox.vue";
import { privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";

export default {
    name: 'PortfolioKpiCard',
    components: {
        PercentBox,
        PortfolioKpiValueChange,
    },

    mixins: [privacyModeTextFormatterMixin],

    props: {
        fromDate: {
            type: String,
            default: null,
        },
        value: {
            type: Number,
            default: null,
        },
        navChange: {
            type: Number,
            default: null,
        },
        navChangeRel: {
            type: Number,
            default: null,
        },
        currency: {
            type: String,
            default: null,
        },
        loading: {
            type: Boolean,
            default: true,
        },
    },

    data() {
        return {
            format: new FormatterService()
        }
    },

    methods: {
        openKpiValueChangePopup() {
            this.$root.$emit('request-open-kpi-value-change-popup')
        },
    }
}
